import { z } from "zod";
/** A quantity on the wire: a decimal string with up to three decimal places, as stored in numeric(18,3). */
export const Quantity = z
    .string()
    .regex(/^(0|[1-9]\d{0,14})(\.\d{1,3})?$/)
    .meta({
    id: "Quantity",
    description: "A non-negative decimal with up to three decimal places, as a string",
});
//# sourceMappingURL=quantity.js.map